import React from 'react';
import { ModalProps } from 'antd';

import { StyledAntdModal } from './style';

const CVModal = (props: React.PropsWithChildren<ModalProps>): JSX.Element => (
  <StyledAntdModal {...props} />
);

export default CVModal;
